import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { HttpClient, HttpParams } from "@angular/common/http";
import { RiskIndicator } from "../../interfaces/riskIndicator";
import { Router } from "@angular/router";

@Injectable()
export class RiskIndicatorService {
  env: any = environment;

  constructor(private http: HttpClient, private router: Router) {}

  getRiskIndicatorsByProjectId(projectId): Promise<RiskIndicator[]> {
    return new Promise((resolve, reject) => {
      const params = new HttpParams().set("projectId", projectId);
      this.http
        .get<any>(this.env.managirUrl + "/riskIndicators", {
          params: params,
          headers: { "Content-Type": "application/json" },
        })
        .toPromise()
        .then((response) => {
          resolve(response.RiskIndicatorResponse.riskindicators);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  }

  getRiskIndicatorByShortId(shortId): Promise<RiskIndicator> {
    return new Promise((resolve, reject) => {
      const params = new HttpParams().set("shortId", shortId);
      this.http
        .get<any>(this.env.managirUrl + "/riskIndicators", {
          params: params,
          headers: { "Content-Type": "application/json" },
        })
        .toPromise()
        .then((response) => {
          resolve(response.RiskIndicatorResponse.riskindicators[0]);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
          /**
           * check if user has access on project and if project does exist
           */
          if (error.status === 404 || error.status === 403) {
            this.router.navigate(["/" + error.status]);
          }
        });
    });
  }

  createRiskIndicator(riskIndicator): Promise<RiskIndicator> {
    return new Promise((resolve, reject) => {
      this.http
        .post<any>(this.env.managirUrl + "/riskIndicators", riskIndicator, {
          headers: { "Content-Type": "application/json" },
        })
        .toPromise()
        .then((response) => {
          resolve(response.RiskIndicatorResponse.riskindicators[0]);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  }

  saveRiskIndicator(riskIndicator) {
    return new Promise((resolve, reject) => {
      this.http
        .put<any>(
          this.env.managirUrl + "/riskIndicators/" + riskIndicator._id,
          riskIndicator,
          {
            headers: { "Content-Type": "application/json" },
          }
        )
        .toPromise()
        .then((response) => {
          resolve(response.RiskIndicatorResponse.riskindicators[0]);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  }

  deleteRiskIndicatorById(riskIndicatorId) {
    return new Promise((resolve, reject) => {
      this.http
        .delete<any>(
          this.env.managirUrl + "/riskIndicators/" + riskIndicatorId,
          {
            headers: { "Content-Type": "application/json" },
          }
        )
        .toPromise()
        .then((response) => {
          resolve(response.message);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  }
}



// WEBPACK FOOTER //
// /agir/src/app/services/risk-indicator/risk-indicator.service.ts